/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.59"
        height="101.1"
        viewBox="0 0 95.59 101.1"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M47.79 31.93a1.26 1.26 0 0 1 1.25 1.13v8a1.25 1.25 0 0 1-2.49.13v-8.01a1.25 1.25 0 0 1 1.24-1.25Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M57.5 39.86a1.24 1.24 0 0 1 1.25 1.25 1.26 1.26 0 0 1-1.12 1.25H38.05a1.25 1.25 0 0 1-.13-2.49H57.5ZM33.13 3.26v2.5h-4.35v6.88c0 3.6 1.19 5.07 4.19 5.3h.23l-.12 2.56c-4.47-.23-6.7-2.74-6.79-7.5V5.13a1.88 1.88 0 0 1 1.73-1.87h5.12ZM67.43 3.26a1.87 1.87 0 0 1 1.87 1.72v7.66c0 4.86-2.14 7.46-6.51 7.79l-.29.07-.13-2.5c3.1-.16 4.36-1.55 4.42-5V5.76H62.5v-2.5Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M60.5 0H35.1a1.9 1.9 0 0 0-1.89 1.9v18A14.58 14.58 0 0 0 47.5 34.43h.32a14.58 14.58 0 0 0 14.56-14.58v-18A1.9 1.9 0 0 0 60.5 0ZM35.71 2.5h24.17v17.35A12.09 12.09 0 0 1 48.1 31.93h-.31a12.08 12.08 0 0 1-12.08-12.08Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M52.61 12.5a.67.67 0 0 0-.85-.44l-3.56 1.17V9.55a.65.65 0 1 0-1.29 0v3.68l-3.57-1.15a.68.68 0 1 0-.4 1.29l3.56 1.13-2.2 3a.65.65 0 0 0 1 .76l2.2-3 2.21 3a.63.63 0 0 0 .9.14.64.64 0 0 0 .15-.9l-2.16-3 3.57-1.15a.68.68 0 0 0 .44-.85"
          className="icon-fill icon-accent"
          fillRule="evenodd"/><path
          fill="#ffb81c"
          d="M47.55 8.4a1.15 1.15 0 0 1 1.14 1v3.1l2.92-.94a1.18 1.18 0 0 1 1.43.65v.12a1.18 1.18 0 0 1-.65 1.43l-.12.05-2.91.94 1.8 2.47a1.16 1.16 0 0 1-.15 1.53l-.1.08a1.15 1.15 0 0 1-1.53-.16l-.08-.09-1.8-2.48-1.8 2.48a1.14 1.14 0 0 1-1.5.32l-.1-.07a1.15 1.15 0 0 1-.32-1.5l.07-.11 1.79-2.47-2.9-.94a1.19 1.19 0 0 1-.76-1.31v-.13a1.16 1.16 0 0 1 1.35-.8h.13l2.91.94v-3a1.14 1.14 0 0 1 1-1.14Zm4.59 4.27a.23.23 0 0 0-.17-.13l-4.27 1.38V9.55a.15.15 0 0 0-.15-.15.15.15 0 0 0-.14.1v4.42l-4.22-1.37a.18.18 0 0 0-.22.12.19.19 0 0 0 .07.2l4.22 1.36-2.6 3.59a.15.15 0 0 0 0 .21.14.14 0 0 0 .17 0l2.6-3.59 2.61 3.59a.16.16 0 0 0 .21 0 .16.16 0 0 0 0-.17l-2.61-3.59 4.23-1.37a.17.17 0 0 0 .12-.16Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M81 54.42a1.26 1.26 0 0 1 1.25 1.08v8.42a1.25 1.25 0 0 1-2.49.13v-7.13H15.83v7a1.26 1.26 0 0 1-1.12 1.25h-.13a1.25 1.25 0 0 1-1.24-1.12v-8.38a1.27 1.27 0 0 1 1.16-1.25H81Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M47.79 48.6a1.26 1.26 0 0 1 1.25 1.12v6a1.25 1.25 0 0 1-2.49.13v-6a1.24 1.24 0 0 1 1.24-1.25Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M14.58 71.44a8.17 8.17 0 1 0 8.17 8.17 8.17 8.17 0 0 0-8.17-8.17Zm0 2.5a5.67 5.67 0 1 1-5.66 5.67 5.67 5.67 0 0 1 5.66-5.67ZM21.37 91.08a7.81 7.81 0 0 1 7.8 7.55v1.22a1.25 1.25 0 0 1-2.49.13v-1.1a5.31 5.31 0 0 0-5.08-5.3H7.8a5.31 5.31 0 0 0-5.3 5.08v1.19a1.25 1.25 0 0 1-2.49.13v-1.1a7.8 7.8 0 0 1 7.55-7.8h13.81ZM81 71.44a8.17 8.17 0 1 0 8.17 8.17A8.16 8.16 0 0 0 81 71.44Zm0 2.5a5.67 5.67 0 1 1-5.66 5.67A5.67 5.67 0 0 1 81 73.94ZM87.79 91.08a7.8 7.8 0 0 1 7.79 7.55v1.22a1.252 1.252 0 0 1-2.5.13v-1.1a5.31 5.31 0 0 0-5.09-5.3H74.22a5.3 5.3 0 0 0-5.3 5.08v1.19a1.252 1.252 0 0 1-2.5.13v-1.1a7.8 7.8 0 0 1 7.55-7.8h13.82Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'TwoPersonTournamentBracketWithTrophyIcon';

export default Icon;
